import { useMemo } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByCOutDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData | undefined;
};

export const useReservationListByCOutDateQueryData = ({ serverData }: Props) => {
	return useMemo(
		(): Result => ({
			queryData: serverData
				? {
						hotelName: serverData.reservationListByCOutDate.hotelName,
						hotelPrefecture: serverData.reservationListByCOutDate.hotelPrefecture,
						reservationList: serverData.reservationListByCOutDate.reservations,
					}
				: undefined,
		}),
		[serverData],
	);
};
